/**
 * Basis provenance — where a lot's Unit Basis came from, derived from the
 * Source ID prefix stamped on every transaction-created lot. Drives the
 * soft-lock on the Unit Basis field in the card/sealed edit forms: derived
 * basis is read-only by default (with an Override escape hatch), because
 * editing it by hand silently breaks COGS, realized gains, and the tie back
 * to the source transaction. Rip pulls get NO override — saveCard triggers
 * rip-basis reallocation, which would recompute a manual value anyway.
 */
export interface BasisProvenance {
  kind: "rip" | "trade" | "purchase" | "adjustment";
  /** Plain-English "how this number was calculated". */
  how: string;
  /** Whether the Override escape hatch is offered. */
  overridable: boolean;
}

export function basisProvenance(sourceId: string | null | undefined): BasisProvenance | null {
  const s = String(sourceId || "").trim();
  if (!s) return null;
  if (/^R-/i.test(s))   return { kind: "rip",        overridable: false, how: "allocated from the box cost across all pulls (FMV-weighted). It is recalculated automatically whenever the rip changes \u2014 manual edits here get recomputed away. Adjust via the rip itself or the rip basis repair tool in Configs" };
  if (/^TR-/i.test(s))  return { kind: "trade",      overridable: true,  how: "allocated from the trade's value received plus cash boot; the trade's realized gain was booked against it" };
  if (/^PUR-/i.test(s)) return { kind: "purchase",   overridable: true,  how: "set from the purchase item's unit cost plus its share of the purchase's fees/tax/shipping (and any capitalized grading fees)" };
  if (/^TXN-/i.test(s)) return { kind: "adjustment", overridable: true,  how: "set by the inventory adjustment that created this lot" };
  return null;
}
